// Dependecies
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';
import { I18nextProvider, initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18next from 'i18next';
import Main from './Router';

// Json
import routersEs from './language/es/routers.json';
import routersEn from './language/en/routers.json';
import plansEs from './language/es/plans.json';
import plansEn from './language/en/plans.json';
import menuEs from './language/es/menu.json';
import menuEn from './language/en/menu.json';
import footerEs from './language/es/footer.json';
import footerEn from './language/en/footer.json';
import registerEs from './language/es/register.json';
import registerEn from './language/en/register.json';
import loginEs from './language/es/login.json';
import loginEn from './language/en/login.json';
import homeEs from './language/es/home.json';
import homeEn from './language/en/home.json';
import sliderEs from './language/es/slider.json';
import sliderEn from './language/en/slider.json';
import validatePasswordEs from './language/es/validatePassword.json';
import validatePasswordEn from './language/en/validatePassword.json';
import internalMenuEs from './language/es/internalMenu.json';
import internalMenuEn from './language/en/internalMenu.json';
import privateMenuEs from './language/es/privateMenu.json';
import privateMenuEn from './language/en/privateMenu.json';
import profileWorkshopEs from './language/es/profileWorkshop.json';
import profileWorkshopEn from './language/en/profileWorkshop.json';
import alertEs from './language/es/alert.json';
import alertEn from './language/en/alert.json';
import maintenanceEs from './language/es/maintenance.json';
import maintenanceEn from './language/en/maintenance.json';
import modalEs from './language/es/modal.json';
import modalEn from './language/en/modal.json';
import benefitEs from './language/es/benefit.json';
import benefitEn from './language/en/benefit.json';
import profileCompanyEs from './language/es/profileCompany.json';
import profileCompanyEn from './language/en/profileCompany.json';
import maintenanceHistoryEs from './language/es/maintenanceHistory.json';
import maintenanceHistoryEn from './language/en/maintenanceHistory.json';
import maintenanceCompanyEs from './language/es/maintenanceCompany.json';
import maintenanceCompanyEn from './language/en/maintenanceCompany.json';
import changePasswordEs from './language/es/changePassword.json';
import changePasswordEn from './language/en/changePassword.json';
import jobRequestEs from './language/es/jobRequest.json';
import jobRequestEn from './language/en/jobRequest.json';
import reportEs from './language/es/report.json';
import reportEn from './language/en/report.json';
import qualityServiceEs from './language/es/qualityService.json';
import qualityServiceEn from './language/en/qualityService.json';
import altEs from './language/es/alt.json';
import altEn from './language/en/alt.json';
import vehicleEs from './language/es/vehicle.json';
import vehicleEn from './language/en/vehicle.json';
import dahsboardEs from './language/es/dahsboard.json';
import dahsboardEn from './language/en/dahsboard.json';
import driverRegistrationEs from './language/es/driverRegistration.json';
import driverRegistrationEn from './language/en/driverRegistration.json';
import infoServiceEs from './language/es/infoService.json';
import infoServiceEn from './language/en/infoService.json';
import formInApprovalEs from './language/es/formInApproval.json';
import formInApprovalEn from './language/en/formInApproval.json';
import storageEs from './language/es/storage.json';
import storageEn from './language/en/storage.json';


const supportedLanguages = ['en', 'es'];

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    whitelist: supportedLanguages,
    fallbackLng: 'es',
    debug: false,
    interpolation: { escapeValue: false },
    resources: {
      es: {
        routers: routersEs,
        plans: plansEs,
        menu: menuEs,
        footer: footerEs,
        register: registerEs,
        login: loginEs,
        home: homeEs,
        slider: sliderEs,
        validatePassword: validatePasswordEs,
        internalMenu: internalMenuEs,
        privateMenu: privateMenuEs,
        profileWorkshop: profileWorkshopEs,
        alert: alertEs,
        maintenance: maintenanceEs,
        modal: modalEs,
        benefit: benefitEs,
        profileCompany: profileCompanyEs,
        maintenanceHistory: maintenanceHistoryEs,
        maintenanceCompany: maintenanceCompanyEs,
        changePassword: changePasswordEs,
        jobRequest: jobRequestEs,
        report: reportEs,
        qualityService: qualityServiceEs,
        alt: altEs,
        vehicle: vehicleEs,
        dahsboard: dahsboardEs,
        driverRegistration: driverRegistrationEs,
        infoService: infoServiceEs,
        formInApproval: formInApprovalEs,
        storage: storageEs,
      },
      en: {
        routers: routersEn,
        plans: plansEn,
        menu: menuEn,
        footer: footerEn,
        register: registerEn,
        login: loginEn,
        home: homeEn,
        slider: sliderEn,
        validatePassword: validatePasswordEn,
        internalMenu: internalMenuEn,
        privateMenu: privateMenuEn,
        profileWorkshop: profileWorkshopEn,
        alert: alertEn,
        maintenance: maintenanceEn,
        modal: modalEn,
        benefit: benefitEn,
        profileCompany: profileCompanyEn,
        maintenanceHistory: maintenanceHistoryEn,
        maintenanceCompany: maintenanceCompanyEn,
        changePassword: changePasswordEn,
        jobRequest: jobRequestEn,
        report: reportEn,
        qualityService: qualityServiceEn,
        alt: altEn,
        vehicle: vehicleEn,
        dahsboard: dahsboardEn,
        driverRegistration: driverRegistrationEn,
        infoService: infoServiceEn,
        formInApproval: formInApprovalEn,
        storage: storageEn,
      },
    },
    detection: {
      order: ['path', 'navigator'],
    },
  });

function Index() {
  return (
    <>
      <I18nextProvider i18n={i18next}>
        <BrowserRouter>
          <Route component={Main} />
        </BrowserRouter>
      </I18nextProvider>
      <div id="modal" />
    </>
  );
}

ReactDOM.render(<Index />, document.getElementById('index'));
